import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { inject, NgModule } from '@angular/core';

import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';



import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PayService } from './service/pay.service';
import { AuthenticationService } from './service/security/authentication.service';
import { RoleGuardService } from './service/security/role-guard.service';
import { JwtModule } from '@auth0/angular-jwt';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { PublicModule } from './public/public.module';
import { UserModule } from './user/user.module';
import { AdminModule } from './admin/admin.module';
import { PartenaireModule } from './partenaire/partenaire.module';
import { PartnerModule } from './partner/partner.module';
import { JwtRefreshInterceptor } from './service/security/jwt-refresh.interceptor';
import { BalanceSyncInterceptor } from './service/security/balance-sync.interceptor';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export function tokenGetter() {
    return localStorage.getItem("tokenConnectedUserWSU1234567GHTVB");
}
@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        HammerModule,
        PublicModule,
        UserModule,
        AdminModule,
        PartenaireModule,
        PartnerModule,

        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
            }
        }),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        TranslateModule.forRoot({
            loader: provideTranslateHttpLoader({
                prefix: './assets/i18n/',
                suffix: '.json'
            })
        })


    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        PayService,
        RoleGuardService,
        AuthenticationService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtRefreshInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: BalanceSyncInterceptor, multi: true },
    ]
})
export class AppModule { }
